import unescapedText from 'I18n/utils/unescapedText';
// TODO: Handle errors, like network errors, etc.
export const getVariantName = asset => asset !== null && asset !== void 0 && asset.status ? unescapedText(`personalizationLib.variantSelect.options.${asset.status}`, {
  name: asset.name
}) : asset === null || asset === void 0 ? void 0 : asset.name;

/**
 * ABM variants are identified by the CRM object (company or contact) they are targeted at, rather
 * than by the generated page name. Variants without a resolved CRM target, like the default asset,
 * fall back to the asset name so that every entry stays identifiable.
 */
export const getABMVariantName = (asset, crmObjectName) => crmObjectName !== null && crmObjectName !== void 0 ? crmObjectName : asset === null || asset === void 0 ? void 0 : asset.name;